export default "__VITE_ASSET__aa5d1b48__"